{
  "Upload picture": "Ladda upp foto",
  "allowed-file-types": "Bara filer i format PNG eller JPG tillåtna  — <0>(Max storlek 4 MB)</0>",
  "Choose a file…": "Välj en fil",
  "Upload": "Ladda upp",
  "Reset": "Återställ",
  "Profile picture": "Profilbild",
  "Original picture": "Originalbild"
}
